import htmlUnescape from '@intercom/embercom-composer/lib/html-unescape-string';
import Constants from '@intercom/embercom-composer/lib/constants';
// inspired by https://github.com/tildeio/simple-html-tokenizer

const CONFIG_FLAG_TO_TAG_MAPPING = {
  allowAnchor: 'a',
  allowBold: 'b',
  allowItalic: 'i',
  allowCode: 'code',
  allowAttribute: 'ic-attribute',
  allowMention: 'ic-mention'
};
function Tokenizer(input, config) {
  this.state = 'text';
  this.index = 0;
  this.input = input;
  this.text = '';
  this.allowedTags = ['br', 'ic-marker'];
  if (config) {
    for (let key in CONFIG_FLAG_TO_TAG_MAPPING) {
      if (config.get(key)) {
        this.allowedTags.push(CONFIG_FLAG_TO_TAG_MAPPING[key]);
      }
    }
  }
}
Tokenizer.prototype = {
  tokenize() {
    this.tokens = {
      openers: [],
      closers: []
    };
    let token;

    //eslint-disable-next-line no-constant-condition
    while (true) {
      token = this.lex();
      if (token === 'EOF') {
        break;
      }
      if (token && this.allowedTags.includes(token.name)) {
        if (token.name === 'br') {
          this.addText(Constants.NEW_LINE);
        } else {
          this.tokens[`${token.type}s`].push(token);
        }
      }
    }
    this.tokens.text = this.text;
    return this.tokens;
  },
  lex() {
    let char = this.input.charAt(this.index++);
    if (char) {
      return this.states[this.state].call(this, char);
    } else {
      return 'EOF';
    }
  },
  addText(char) {
    if (!this.hasActiveEscapeChar) {
      this.text += char;
    }
  },
  emitTag() {
    this.state = 'text';
    if (this.hasActiveEscapeChar && this.tag.name === 'ic-attribute') {
      this.inEscapedAttribute = true;
      this.emitEscapedIcAttribute();
    } else if (this.hasActiveEscapeChar && !this.inEscapedAttribute) {
      this.hasActiveEscapeChar = false;
      return this.tag;
    } else if (!this.hasActiveEscapeChar) {
      return this.tag;
    }
  },
  emitEscapedIcAttribute() {
    let type = this.tag.type;
    if (type === 'opener') {
      this.text += `{{ ${this.tag['data-identifier']}`;
      this.escapedIcAttributeFallback = this.tag['data-fallback'].trim();
    } else if (type === 'closer') {
      if (this.escapedIcAttributeFallback) {
        this.text += ` | fallback: "${this.escapedIcAttributeFallback}"`;
      }
      this.text += ' }}';
      this.hasActiveEscapeChar = false;
      this.inEscapedAttribute = false;
    }
  },
  emitAttribute() {
    this.tag[this.attribute.name] = this.attribute.value;
    this.state = 'beforeAttributeName';
  },
  startTag(type, char) {
    this.tag = new Tag(type);
    this.tag.name = char;
    this.tag.atIndex = this.text.length;
    this.state = 'tagName';
  },
  startAttribute(char) {
    this.attribute = new Attribute();
    this.attribute.name = char;
    this.state = 'attributeName';
  },
  addToTagName(char) {
    this.tag.name += char;
  },
  addToAttributeName(char) {
    this.attribute.name += char;
  },
  addToAttributeValue(char) {
    this.attribute.value += char;
  },
  consumeCharRef() {
    let entityBuffer = '&';
    let input = this.input;
    let i = this.index;
    while (input[i] !== ';' && i < input.length) {
      entityBuffer += input[i];
      i++;
    }
    if (input[i] !== ';') {
      return false;
    } else {
      entityBuffer += ';';
    }
    this.index += entityBuffer.length - 1;
    return htmlUnescape(entityBuffer);
  },
  states: {
    text(char) {
      if (char === '<') {
        this.state = 'tagOpen';
      } else if (char === '&') {
        this.addText(this.consumeCharRef() || '&');
      } else if (char === '#') {
        this.addText(char);
        this.state = 'icAttributeEscape';
      } else {
        this.addText(char);
      }
    },
    icAttributeEscape(char) {
      if (char === '<') {
        this.hasActiveEscapeChar = true;
        this.state = 'tagOpen';
      } else {
        this.state = 'text';
        this.states['text'].bind(this)(char);
      }
    },
    tagOpen(char) {
      if (char === '/') {
        this.state = 'endTagOpen';
      } else {
        this.startTag('opener', char);
      }
    },
    endTagOpen(char) {
      this.startTag('closer', char);
    },
    tagName(char) {
      if (char === '>') {
        return this.emitTag();
      } else if (char === ' ') {
        this.state = 'beforeAttributeName';
      } else {
        this.addToTagName(char);
      }
    },
    beforeAttributeName(char) {
      if (char === ' ') {
        return;
      } else if (char === '>') {
        return this.emitTag();
      } else {
        this.startAttribute(char);
      }
    },
    attributeName(char) {
      if (char === '=') {
        this.state = 'beforeAttributeValue';
      } else if (char === ' ') {
        this.state = 'afterAttributeName';
      } else {
        this.addToAttributeName(char);
      }
    },
    afterAttributeName(char) {
      if (char === ' ') {
        return;
      } else if (char === '>') {
        this.emitTag();
      }
    },
    beforeAttributeValue(char) {
      if (char === '"') {
        this.state = 'attributeValue';
      } else if (char === '>') {
        this.emitTag();
      }
    },
    attributeValue(char) {
      if (char === '"') {
        this.emitAttribute();
      } else {
        this.addToAttributeValue(char);
      }
    }
  }
};
const Tag = function (type) {
  this.type = type;
};
Tag.prototype = {
  type: '',
  name: '',
  atIndex: 0
};
const Attribute = function () {};
Attribute.prototype = {
  name: '',
  value: ''
};
export default Tokenizer;